import Harry from './players/110254-Harry Messenger.json';
import Sharkey from './players/113299-Michael Sharkey.json';
import Steve from './players/127441-Steve Edwards.json';
import Rob from './players/146166-Robert Nicoll.json';
import Jason from './players/149671-Jason McNeice.json';
import Danny from './players/150264-Daniel Greenhalgh.json';
import Matt from './players/162745-Matt Lee.json';
import TomM from './players/164927-Tom Messenger.json';
import Tony from './players/171459-Tony Todd-Miller.json';
import Tom from './players/171506-Thomas Moon.json';
import Brandon from './players/171629-Brandon Lawson.json';
import Bob from "./players/180314-Bob O'Leary.json";
import Luke from './players/182987-Luke Dodd Adkins.json';
import Max from './players/194115-Maximilian Berkmann.json';
import Nathan from './players/203084-Nathan Rae.json';
import Pete from './players/203514-Peter Foden.json';
import Kai from './players/205686-Kai Birch.json';
import Stuart from './players/215485-Stuart Lyon.json';
import Nick from './players/217503-Nick Meddows.json';
import Jim from './players/221027-Jim Spencer.json';
import Mike from './players/225151-Mike Beard.json';
import Ben from './players/230833-Ben Curphey.json';

const Friends = [
  Harry,
  Sharkey,
  Steve,
  Rob,
  Jason,
  Danny,
  Matt,
  TomM,
  Tony,
  Tom,
  Brandon,
  Bob,
  Luke,
  Max,
  Nathan,
  Pete,
  Kai,
  Stuart,
  Nick,
  Jim,
  Mike,
  Ben
];

export default Friends;
